module.exports = __webpack_public_path__ + "img/no-question.d7b0de2b.png";